
export const formDockToDto = (dock) => {
    return {
        dockID: dock.dockID,
        dockName: dock.dockName,
        dockCode: dock.dockCode,
        streetNo: dock.dockStreetNo,
        streetName: dock.dockStreetName,
        country: dock?.dockCountry === "USA" ? 2 : 1,
        postalCode: dock.dockPostalCode,
        isPrimary: dock.isPrimary,
        cityName: dock?.dockCity,
        province: dock?.dockProvinceID,
        city: [{ name: dock?.dockCity, id: dock?.dockCityID }],
        provinceList: { data: { data: [{ provineStateID: dock?.dockProvinceID, provineSateName: dock?.dockProvince }] } },
        countryList: { data: { data: [{ countryId: dock?.dockCountryID, countryname: dock?.dockCountry }] } },
    }
};

export const billingToDto = ({ companyProfile }) => {
    return {
        sameAsCompanyProfile: companyProfile?.isBillingSameAsMailing,
        streetNo: companyProfile?.billingStreetNo,
        streetName: companyProfile?.billingStreetName,
        cityName: companyProfile?.billingCity,
        province: companyProfile?.billingProvinceID,
        country: companyProfile?.billingCountry === "USA" ? 2 : 1,
        postalCode: companyProfile?.billingPostalCode,
        city: [{ name: companyProfile?.billingCity, id: companyProfile?.billingCityID }],
        provinceList: { data: { data: [{ provineStateID: companyProfile?.billingProvinceID, provineSateName: companyProfile?.billingProvince }] } },
        countryList: { data: { data: [{ countryId: companyProfile?.billingCountryID, countryname: companyProfile?.billingCountry }] } },
    }
}

export const receivableToDto = ({ companyProfile }) => {
    return {
        sameAsCompanyProfile: companyProfile?.isReceivableSameAsMailing,
        streetNo: companyProfile?.receivableStreetNo,
        streetName: companyProfile?.receivableStreetName,
        cityName: companyProfile?.receivableCity,
        province: companyProfile?.receivableProvinceID,
        country: companyProfile?.receivableCountry === "USA" ? 2 : 1,
        postalCode: companyProfile?.receivablePostalCode,
        city: [{ name: companyProfile?.receivableCity, id: companyProfile?.receivableCityID }],
        provinceList: { data: { data: [{ provineStateID: companyProfile?.receivableProvinceID, provineSateName: companyProfile?.receivableProvince }] } },
        countryList: { data: { data: [{ countryId: companyProfile?.receivableCountryID, countryname: companyProfile?.receivableCountry }] } },
    }
}
export const companyProfileToDto = ({ companyProfile }) => {
    return {
        city: [{ name: companyProfile?.city, id: companyProfile?.cityID }],
        province: companyProfile?.provinceID,
        country: companyProfile?.countryID,
        provinceList: { data: { data: [{ provineStateID: companyProfile?.provinceID, provineSateName: companyProfile?.province }] } },
        countryList: { data: { data: [{ countryId: companyProfile?.countryID, countryname: companyProfile?.country }] } },
    }
}

export const defaultNestedValues = {
    sameAsCompanyProfile: false,
    streetNo: "",
    streetName: "",
    city: [],
    province: "",
    country: "",
    postalCode: "",
    provinceList: { data: [] },
    countryList: { data: [] },
}

export const defaultValues = {
    companyProfile: {
        city: [],
        province: "",
        country: "",
        provinceList: { data: [] },
        countryList: { data: [] },
    },
    unit: "",
    contact: "",
    phoneExt: "",
    openTime: "",
    closeTime: "",
    locationNotes: "",
    companyName: "",
    streetNo: "",
    streetName: "",
    postalCode: "",
    email: "",
    phoneNumber: "",
    faxNumber: "",
    businessNumber: "",
    taxNumber: "",
    division: "",
    website: "",
    divisionPrefix: "",
    icon: "",
    billing: defaultNestedValues,
    receivable: defaultNestedValues,
    docks: [],
    dockForm: {
        ...defaultNestedValues,
        dockName: "",
        isPrimary: false
    },
}